import { Outlet } from "react-router";

import { Providers } from "@/app/providers";

export default function RootLayout() {
  return (
    <Providers>
      <Outlet />
    </Providers>
  );
}
